export default "/swap-tokens.12b22d8c25aa5d0cbafcc9e17589c936.png";